export default __webpack_public_path__ + "static/media/d-4.3738ba23.png";